import { Routes, Route, Navigate } from "react-router-dom";
import { featureFlags } from "shared/config/featureFlags";
import {
  Home,
  Login,
  CdUsuario,
  CadastroSucesso,
  RecuperarSenha,
  SenhaRecuperada,
  FinalizarPedido,
  Carrinho,
  Produto,
  MeusEnderecos,
  MinhasCompras,
  Favoritos,
  TodasNotificacoes,
  MeusProdutos,
  Ajuda,
  Sobre,
  ConfirmarPedido,
  EditarProduto,
  CdLoja,
  Configuracoes,
  MinhasVendas,
  NovaSenha,
  CdProduto,
  MinhasLojas,
  VisualizarLoja,
  MeusCupons,
  MinhaConta,
  CdEndereco,
  EditarEndereco,
  EditarLoja,
  CdCupom,
  TodasCategorias,
  CuponsDesconto,
  Relatorios,
  Reportar,
  ConfirmarEmail,
  ProdutoCadastrado,
  LojaProdutos,
  ListarProdutos,
  MetodoPagamento,
  PagamentoBoleto,
  PagamentoPix,
  AdministracaoV2Layout,
  VariacoesGlobais,
  DetalhesPedido
} from "../pages";
import Layout from "shared/layouts/Layout";
import { PrivateRoute } from "./PrivateRoute";
import { LojaGuard } from "./guard/LojaGuard";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* HOME */}
        <Route index element={<Home />} />

        {/* PÚBLICO */}
        {featureFlags.coupons && <Route path="cupons" element={<CuponsDesconto />} />}
        <Route path="login" element={<Login />} />
        <Route path="usuario/cadastrar" element={<CdUsuario />} />
        <Route path="confirmar-email" element={<ConfirmarEmail />} />
        <Route path="usuario/cadastrosucesso" element={<CadastroSucesso />} />
        <Route path="usuario/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="novasenha" element={<NovaSenha />} />
        <Route path="senhaenviada" element={<SenhaRecuperada />} />

        {/* USUÁRIO LOGADO */}
        <Route element={<PrivateRoute />}>
          <Route path="cadastroloja" element={<CdLoja />} />
          <Route path="minhaslojas" element={<MinhasLojas />} />
          <Route path="editarloja/:id" element={<EditarLoja />} />
          <Route path="cadastroendereco" element={<CdEndereco />} />
          <Route path="editarendereco/:id" element={<EditarEndereco />} />
          <Route path="loja/:id" element={<VisualizarLoja />} />
          <Route path="minhaconta" element={<MinhaConta />} />
          <Route path="metodopagamento" element={<MetodoPagamento />} />
          <Route path="meusenderecos" element={<MeusEnderecos />} />
          {featureFlags.checkout && (
            <>
              <Route path="minhascompras" element={<MinhasCompras />} />
              <Route path="minhascompras/:id/detalhes" element={<DetalhesPedido tipo="compra" />} />
            </>
          )}
          {featureFlags.coupons && (
            <>
              <Route path="meuscupons" element={<MeusCupons />} />
              <Route path="meuscupons/criarcupom" element={<CdCupom />} />
            </>
          )}
          <Route path="favoritos" element={<Favoritos />} />
          {featureFlags.notifications && <Route path="todasnotificacoes" element={<TodasNotificacoes />} />}
        </Route>

        {/* LOJISTA */}
        <Route element={<PrivateRoute requireVendedor />}>
          <Route path="meusprodutos" element={<MeusProdutos />} />
          <Route path="produto-cadastrado" element={<ProdutoCadastrado />} />
          <Route element={<LojaGuard />}>
            <Route path="cadastroproduto" element={<CdProduto />} />
            <Route path="editarproduto/:id" element={<EditarProduto />} />
          </Route>
          {featureFlags.checkout && (
            <>
              <Route path="minhasvendas" element={<MinhasVendas />} />
              <Route path="minhasvendas/:id/detalhes" element={<DetalhesPedido tipo="venda" />} />
              <Route path="relatorios" element={<Relatorios />} />
            </>
          )}
          <Route path="reportar" element={<Reportar />} />
        </Route>

        {/* ADMIN V2 */}
        <Route element={<PrivateRoute requireAdmin />}>
          <Route path="admin/v2" element={<AdministracaoV2Layout />}>
            <Route index element={<Navigate to="variacoes" replace />} />
            <Route path="variacoes" element={<VariacoesGlobais />} />
            <Route path="variacoes/:id/editar" element={<VariacoesGlobais />} />
          </Route>
        </Route>

        {/* CARRINHO */}
        <Route path="carrinho" element={<Carrinho />} />
        {featureFlags.checkout && (
          <>
            <Route path="carrinho/finalizar" element={<FinalizarPedido />} />
            <Route path="carrinho/confirmar" element={<ConfirmarPedido />} />
            <Route path="pagamento/pix" element={<PagamentoPix />} />
            <Route path="pagamento/boleto" element={<PagamentoBoleto />} />
          </>
        )}

        {/* PRODUTOS */}
        <Route path="listarprodutos" element={<ListarProdutos />} />
        <Route path="produto/:id" element={<Produto />} />
        <Route path="categorias" element={<TodasCategorias />} />
        <Route path="lojas/:id" element={<LojaProdutos />} />

        {/* OUTROS */}
        <Route path="ajuda" element={<Ajuda />} />
        <Route path="sobre" element={<Sobre />} />
        <Route path="configuracoes" element={<Configuracoes />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};